import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { AggregateHexagon } from '~map-preview/App/Tools/MapToolbar/Hexagon/AggregateHexagon'
import { HexaggonDimensionalDisplay } from '~map-preview/App/Tools/MapToolbar/Hexagon/HexagonDimensionalDisplay'
import { HexagonSize } from '~map-preview/App/Tools/MapToolbar/Hexagon/HexagonSize'
import { setSize } from '~map-preview/states/hexagons'
import {
  LAYER_TYPES,
  LAYER_TYPE_TITLE,
  setLayerType,
  setLayerTypeTitle
} from '~map-preview/states/layerType'
import { useMapToolbarStore } from '~map-preview/states/mapToolbar'
import { Hexagon as HexagonType } from '~map-preview/types/__generated/gql/graphql'

import { openMapLegend } from '~map-preview/states/ui'

export const Hexagon = (props) => {
  const dispatch = useDispatch()
  const { visualization, setVisualization } = useMapToolbarStore()

  useEffect(() => {
    if (visualization) {
      const selected: HexagonType | undefined =
        visualization &&
        (Object.values(visualization)[0] as HexagonType | undefined)
      if (selected?.id === 'hexagon') {
        dispatch(setLayerType(LAYER_TYPES.HEXAGON))
        dispatch(setLayerTypeTitle(LAYER_TYPE_TITLE[LAYER_TYPES.HEXAGON]))
        dispatch(openMapLegend())
        dispatch(setSize(selected?.size))
      }
    }
  }, [visualization])

  return (
    <>
      <AggregateHexagon />
      <HexagonSize />
      <HexaggonDimensionalDisplay />
    </>
  )
}
